<div class="container">
  <header class="page-heading mb-lg">
    <img src="logo.svg" alt="Every Rupee Spent logo" width="56" height="56" class="about-logo">
    <span class="about-eyebrow">About us</span>
    <h1>About Every Rupee Spent</h1>
    <p>
      Accurate, India-first financial calculators that help you understand your money before you make a
      decision — plus a growing suite of premium services, from bill reminders to budgeting, for
      individuals and businesses ready to take the next step.
    </p>
  </header>

  <section class="card mb-lg about-mission">
    <h2 class="section-title">Our mission</h2>
    <p>
      Most people in India make significant financial decisions — a home loan, an SIP, which tax regime
      to choose — based on little more than a rough estimate or a salesperson's pitch. We believe
      everyone deserves to see the real numbers first. Every Rupee Spent exists to make that math
      transparent and trustworthy, so you can plan your loans, taxes, savings and investments with
      confidence. Our calculators are free for exactly that reason; we also offer paid, optional services
      for individuals and businesses who need more than a calculator can provide.
    </p>
  </section>

  <section class="about-stats mb-lg">
    @for (s of stats; track s.label) {
      <div class="about-stat card">
        <span class="about-stat-value">{{ s.value }}</span>
        <span class="about-stat-label">{{ s.label }}</span>
      </div>
    }
  </section>

  <section class="mb-lg">
    <h2 class="section-title about-section-title">What we stand for</h2>
    <div class="about-principles">
      @for (p of principles; track p.title) {
        <div class="about-principle card">
          <h3>{{ p.title }}</h3>
          <p>{{ p.text }}</p>
        </div>
      }
    </div>
  </section>

  <section class="mb-lg">
    <h2 class="section-title about-section-title">What we offer</h2>
    <div class="about-offers">
      <div class="card about-offer">
        <span class="about-offer-badge">Free</span>
        <h3>20+ financial calculators</h3>
        <p>
          EMI, SIP, PPF, EPF, SSY, NPS, HRA, old vs new tax regime and more — free, with no login and no
          data stored, for anyone who wants to run the numbers before deciding.
        </p>
        <a routerLink="/" class="about-offer-link">Explore the calculators →</a>
      </div>
      <div class="card about-offer">
        <span class="about-offer-badge premium">Premium</span>
        <h3>Reminders</h3>
        <p>
          Never miss a credit-card bill, insurance premium or EMI due date again. The free plan covers a
          handful of reminders; Basic, Mid and Premium annual plans raise the limit for households with
          more bills, cards and policies to track.
        </p>
        <a routerLink="/reminders" class="about-offer-link">Set up reminders →</a>
      </div>
      <div class="card about-offer">
        <span class="about-offer-badge premium">Premium</span>
        <h3>Budget & Expense Tracker</h3>
        <p>
          Set a monthly budget, log expenses as you spend, and see exactly where you stand at a glance.
          Free forever for basic tracking; ₹499/year unlocks per-category budgets and full history.
        </p>
        <a routerLink="/budget" class="about-offer-link">Start tracking →</a>
      </div>
      <!-- RMS (Rental Management System) card hidden 2026-07-28 until the feature
           is built end to end.
      <div class="card about-offer">
        <span class="about-offer-badge premium">Premium</span>
        <h3>Rental Management System</h3>
        <p>
          Properties, tenants, leases, rent collection, maintenance and agreements in one place, with a
          self-serve portal for tenants. Free for your first property; paid tiers from ₹599/year add more.
        </p>
        <a routerLink="/rms" class="about-offer-link">Manage your properties →</a>
      </div>
      -->
    </div>
  </section>

  <section class="card mb-lg">
    <h2 class="section-title">How we build our calculators</h2>
    <ol class="about-method">
      @for (step of methodology; track step) {
        <li>{{ step }}</li>
      }
    </ol>
    <p class="about-method-note">
      Our tools are for information and education only — they are not financial advice. Please read our
      <a routerLink="/disclaimer">full disclaimer</a> before acting on any result.
    </p>
  </section>

  <section class="card mb-lg about-founder">
    <h2 class="section-title">Who's behind this</h2>
    <div class="about-founder-body">
      <img src="logo.svg" alt="" width="56" height="56" class="about-founder-avatar" aria-hidden="true">
      <div>
        <p class="about-founder-name">{{ founderName }}</p>
        <p class="about-founder-role">{{ founderRole }}</p>
        <p class="about-founder-bio">{{ founderBio }}</p>
      </div>
    </div>
  </section>

  <section class="card about-cta">
    <h2>Questions, feedback or a correction?</h2>
    <p>
      We take accuracy seriously. If you notice an error or would like to suggest a calculator, we
      welcome your feedback.
    </p>
    <div class="about-cta-actions">
      <a routerLink="/contact" class="about-cta-btn primary">Contact us</a>
      <a routerLink="/" class="about-cta-btn">Explore the calculators</a>
    </div>
  </section>
</div>
